
export enum TypeFilterService {
  Ambito = 1,
  TipoFiltroClasificacion = 2,
  CircuitosRegiones = 3,
  EntidadFederativa = 4,
  TipoOrganismo = 5,
  Materia = 6,
  Organismo = 9,
  TipoAsunto = 7,
  OCC = 8
}

export enum AmbitoEnum {

  None = 0,
  Federal = 1,
  Local = 2,

}
